import React from 'react';
import { StarIcon } from 'lucide-react';
import { googleReviews } from '../data/businessInfo';
import { businessInfo } from '../data/businessInfo';
export const GoogleReviewBadge = () => {
  const avatars = ['https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=80', 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=80', 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=80'];
  return <a href={businessInfo.reviewsUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center bg-white/10 backdrop-blur-sm border border-white/20 rounded-full py-1.5 px-3 shadow-lg hover:bg-white/15 transition-colors duration-300 group" aria-label={`${googleReviews.ratingDisplay} sterren uit ${googleReviews.count} Google reviews — bekijk alle reviews`} data-id="element-235" data-mp="3cyv1hts1lrbs">
      <div className="flex -space-x-1.5 mr-2" data-id="element-236" data-mp="1n7gn91cwhif7">
        {avatars.map((src, i) => <div key={i} className="w-6 h-6 rounded-full border-2 border-black bg-gradient-to-br from-gray-100 to-gray-300 overflow-hidden" style={{
        zIndex: 3 - i,
        backgroundImage: `url(${src})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }} data-id="element-237" data-mp="1n9jl27kaofuh" data-mpi={i} />)}
        <div className="w-6 h-6 rounded-full border-2 border-black bg-black flex items-center justify-center text-[8px] font-bold text-white" style={{
        zIndex: 0
      }} data-id="element-238" data-mp="265t0ay6xncg2">
          +{googleReviews.count - avatars.length}
        </div>
      </div>
      <div className="flex flex-col items-start" data-id="element-239" data-mp="2jwob4g0zs3ma">
        <div className="flex items-center" data-id="element-240" data-mp="2ox2kc1ebxjlw">
          <div className="flex" data-id="element-241" data-mp="2oy3tu1fp5y1i">
            {[...Array(5)].map((_, i) => <StarIcon key={i} size={12} className="text-[#FFD700] fill-[#FFD700] mr-0.5" data-id="element-242" data-mp="2twov846oqnrj" data-mpi={i} />)}
          </div>
          <span className="text-white font-semibold text-xs ml-1" data-id="element-243" data-mp="1z96l1zrfow0m">
            {googleReviews.ratingDisplay}
          </span>
        </div>
        <div className="flex items-center" data-id="element-244" data-mp="2dym8p6vo4lc3">
          <span className="text-white/80 text-[10px]" data-id="element-245" data-mp="296up5gaxjfvg">
            {googleReviews.count} reviews op Google
          </span>
        </div>
      </div>
    </a>;
};